import React, { Component } from 'react'
import { useParams } from 'react-router-dom';
import DetailsNavbar from '../../../Components/DetailsNavbar';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}
const API_URL = process.env.REACT_APP_API_URL

class PersonaFuentes extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [] };
        this.navBar = [
            {nombre: "Detalles", href: `/Persona/details/${props.params.id}`},
            {nombre: "Organizaciones", href: `/Persona/organizaciones/${props.params.id}`},
            {nombre: "Eventos", href: `/Persona/eventos/${props.params.id}`},
            {nombre: "Testimonios", href: `/Persona/testimonios/${props.params.id}`},
            {nombre: "Documentos de Archivos", href: `/Persona/documentos/${props.params.id}`},
            {nombre: "Otras Fuentes", href: `/Persona/fuentes/${props.params.id}`},
            {nombre: "Relaciones", href: `/Persona/relaciones/${props.params.id}`}
        ];
        this.page = "Persona";
        this.default = "fuentes"
    }

    async componentDidMount() {
        try {
            const response = await fetch(`${API_URL}/persona/getById/${this.props.params.id}`);
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            this.setState({ data: data.data });
        } catch (err) {
            console.log(err.message);
        };
    }

    render() {
        return (
            <DetailsNavbar items={this.navBar} page={this.page} id={this.props.params.id} default={this.default} />
        )
    }

}
export default withParams(PersonaFuentes);